import './Credit.css';

import ConfirmDialog from './ConfirmDialog'
import React, { useContext, useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import Credit from './Credit'
export default function CreditModal({ id, show, handleClose }) {
    useEffect(() => {

    }, []);

    const creditRef = useRef(null);
    return (
        <>
            <ConfirmDialog
                show={show}
                title="اعتبار دستگاه ها"
                size="lg"
                handleDo={e => {
                    if (creditRef.current && creditRef.current.addCredit)
                        creditRef.current.addCredit(e);
                }}
                handleCancel={handleClose}
                isBusy={false}
            >
                <Credit ref={creditRef} />
            </ConfirmDialog >
        </>

    );

}
